<template>
    <b-modal :id="modalId" v-if="value" :title="dispenseErrorLabel" @close="closeModal" @show="show" @hide="hide"
        hide-footer :no-close-on-backdrop="!reviewMode">

        <router-link v-if="value && value.id" :to="{
            name: PV
            , params: { storeID: value.storeID, rxNumber: value.rxNumber, rfNumber: value.rfNumber, dispenseErrorId: value.id , routeMode: 'pendingError'}
        }">
            Go To Prescription Verification
        </router-link>

        <div class="form-group">
            <label for="reason">Reason</label>
            <b-form-textarea id="reason" v-model="value.reason" placeholder="Whats the reason of this error?"
                :disabled="reviewMode" required></b-form-textarea>
        </div>
        <EnumSelector v-model="value.errorType" label="Type" :disabled="disableTypesField" :enum-codes="typeOfErrors"
            required :displayNames="typeOfErrorsCustomDisplayNames" />

        <div v-if="reviewMode">
            <hr>

            <!-- Notes -->
            <div>
                <b>Notes: </b>
                <NotesList :paging="false" :entityId="value.id" :entityType="entityType" />
            </div>

            <div class="form-group">
                <NotesForm :entityId="value.id" :entityType="entityType"
                    :placeholder="'Describe reasons for accepting/rejecting or add comments on the error in general (Not required)'"
                    @saved="onSavingNote" />
            </div>
        </div>

        <!-- Footer -->
        <div v-if="showButtons">
            <hr>
            <b-button variant="success" @click="save" :disabled="!validForm || saving">
                <b-spinner small v-if="saving" class="mr-1"></b-spinner>
                {{ saving ? 'Reporting...' : saveButtonLabel }}
            </b-button>
        </div>

    </b-modal>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { DispenseError } from '@/models/DispenseError';
import EnumSelector from '@/components/EnumSelector.vue';
import NotesList from '@/components/Note/NotesList.vue'
import NotesForm from '@/components/Note/NotesForm.vue'
import { Note } from '@/models/Note';
import { EntityType } from "@/models/EntityType";
import { NotificationOptions } from "@/util/NotificationOptionsPresets";

@Component({
    name: "DispensingErrorModalComponent",
    components: {
        EnumSelector, NotesList, NotesForm
    }
})
export default class DispensingErrorModalComponent extends Vue {
    @Prop() private value!: DispenseError;

    @Prop({ default: "dispense-error-modal" }) private modalId!: string
    @Prop({ default: true }) private showButtons!: boolean
    @Prop({ default: false }) private reviewMode!: boolean
    @Prop({ default: "Report Error" }) private saveButtonLabel!: string
    @Prop({ default: false }) private saving!: boolean

    private typeOfErrors = DispenseError.DispenseErrorTypeEnum;
    private newNote = { body: '' } as Note;
    private typeOfErrorsCustomDisplayNames = DispenseError.ERROR_TYPE_DISPLAY_NAMES;
    private entityType = EntityType.DispenseError;

    mounted() {
        this.fetchDispenseErrorLabel();
    }

    save() {
        this.$emit("onClickSave", this.value);
    }
    accept() {
        this.$emit("onClickAccept", this.value);
    }
    reject() {
        this.$emit("onClickReject", this.value);
    }

    show() {
        this.$emit("errorModalOpened");
    }

    hide() {
        this.$emit("errorModalClosed");
    }

    closeModal() {
        this.newNote.body = '';
    }

    onSavingNote() {
        this.$emit('savedNote', this.value.id)
        this.$bvModal.hide(this.modalId);
    }

    get PV(): string | undefined {
        return this.value.pv?.toUpperCase();
    }

    get validForm() {
        return !!((this.value?.errorType || this.value?.errorType == 0));
    }

    get disableTypesField() {
        if (!this.reviewMode) return false;
        return true;
    }

    private isHandling = false;

    @Watch("value")
    updateValue() {
        this.isHandling = true;
        this.$nextTick(() => {
            this.isHandling = false;
        })
    }

    @Watch("value.errorType")
    async updateErrorType() {
        if (this.isHandling || !this.value?.id) return;

        try {
            const response = await this.$http.post<DispenseError>(`DispenseError/error-type/${this.value.id}/${this.value.errorType}`);

            this.value.errorType = response.data.errorType;
            this.value.notes = response.data.notes;

            this.$notification(NotificationOptions.successSaveNotificationPreset(this.dispenseErrorLabel));

            this.$emit("changed-type");
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
        }
    }

    protected dispenseErrorLabel = "";

    async fetchDispenseErrorLabel() {
        try {
            const resp = await this.$http.get("/Configuration/DispenseErrorLabel");
            this.dispenseErrorLabel = resp.data?.trim();
        } catch {
            this.dispenseErrorLabel = "Error";
            //ignore
        }
    }
}

</script>
